import styled from 'styled-components';

export const StyledGameFormatSelectorModal = styled.div`
  button {
    margin-bottom: 15px;
    width: 250px;
    span {
      svg {
        margin-right: 10px;
      }
    }
  }
`;
